import { render } from "./EstadoList.vue?vue&type=template&id=807054c4&scoped=true"
import script from "./EstadoList.vue?vue&type=script&lang=js"
export * from "./EstadoList.vue?vue&type=script&lang=js"

import "./EstadoList.vue?vue&type=style&index=0&id=807054c4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-807054c4"]])

export default __exports__